/* eslint-disable no-undef, camelcase */

if (typeof window !== 'undefined') {
    const currentScriptSrc = document.currentScript?.src ?? window.requirejs?.toUrl('app/index') ?? null;
    if (currentScriptSrc) {
        __webpack_public_path__ = currentScriptSrc.slice(0, currentScriptSrc.lastIndexOf('/')) + '/';
    }
}
export default null;
